import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Planos from "@/pages/Planos";
import Cadastro from "@/pages/Cadastro";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import CriarQuizIA from "@/pages/CriarQuizIA";
import QuizEditor from "@/pages/QuizEditor";
import QuizVisualizar from "@/pages/QuizVisualizar";
import MeusQuizzes from "@/pages/MeusQuizzes";
import Assinatura from "@/pages/Assinatura";
import Admin from "@/pages/Admin";
import Jogar from "@/pages/Jogar";
import Sala from "@/pages/Sala";
import Apresentar from "@/pages/Apresentar";
import Resultados from "@/pages/Resultados";
import EsqueciSenha from "@/pages/EsqueciSenha";
import RedefinirSenha from "@/pages/RedefinirSenha";
import VerificarEmail from "@/pages/VerificarEmail";
import Atividades from "@/pages/Atividades";
import AtividadesTurma from "@/pages/AtividadesTurma";
import GerenciarAtividades from "@/pages/GerenciarAtividades";
import BibliotecaQuizzes from "@/pages/BibliotecaQuizzes";
import BibliotecaQuiz from "@/pages/BibliotecaQuiz";

function AppRoutes() {
  const location = useLocation();
  // Handle Emergent Google OAuth callback (session_id in URL fragment)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/planos" element={<Planos />} />
      <Route path="/cadastro" element={<Cadastro />} />
      <Route path="/login" element={<Login />} />
      <Route path="/esqueci-senha" element={<EsqueciSenha />} />
      <Route path="/redefinir-senha" element={<RedefinirSenha />} />
      <Route path="/verificar-email" element={<VerificarEmail />} />
      <Route path="/jogar" element={<Jogar />} />
      <Route path="/sala/:pin" element={<Sala />} />
      <Route path="/atividades" element={<Atividades />} />
      <Route path="/atividades/gerenciar" element={<ProtectedRoute roles={["teacher", "admin"]}><GerenciarAtividades /></ProtectedRoute>} />
      <Route path="/atividades/:slug" element={<AtividadesTurma />} />
      <Route path="/biblioteca" element={<BibliotecaQuizzes />} />
      <Route path="/biblioteca/:id" element={<BibliotecaQuiz />} />

      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/quiz/ia" element={<ProtectedRoute><CriarQuizIA /></ProtectedRoute>} />
      <Route path="/quiz/novo" element={<ProtectedRoute><QuizEditor /></ProtectedRoute>} />
      <Route path="/quiz/:id/editar" element={<ProtectedRoute><QuizEditor /></ProtectedRoute>} />
      <Route path="/quiz/:id/visualizar" element={<ProtectedRoute><QuizVisualizar /></ProtectedRoute>} />
      <Route path="/quizzes" element={<ProtectedRoute><MeusQuizzes /></ProtectedRoute>} />
      <Route path="/apresentar/:id" element={<ProtectedRoute><Apresentar /></ProtectedRoute>} />
      <Route path="/resultados" element={<ProtectedRoute><Resultados /></ProtectedRoute>} />
      <Route path="/assinatura" element={<ProtectedRoute><Assinatura /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><Admin /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" richColors />
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
